import {createStore} from 'redux';
import {Reducer} from "./Reducer";

var store = createStore(Reducer);

export default store;